import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Page as Component, type Props } from './Page';
import { PageNotFoundEmptyState } from '../empty-state';
import { I18nProvider } from '../i18n/I18nProvider';
import fetchTranslations from '../i18n/fetchTranslations';

export type PageProps = Props & {
	locale?: string;
	showFooter?: boolean;
};

// Do not place formatMessage / FormattedMessage / useIntl calls here outside of the I18nProvider.
// They will not function correctly due to a lack of I18n context.

export const Page = (props: PageProps): React.JSX.Element => (
	<I18nProvider locale={props.locale} fetchTranslations={fetchTranslations}>
		<ErrorBoundary fallback={<PageNotFoundEmptyState />}>
			<Component {...props} />
		</ErrorBoundary>
	</I18nProvider>
);
